import { ReleaseFlagProvider, UserProvider } from '@libs/contexts';
import { DeleteDialogProvider, GuideTabProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';

function AppContainer() {
  return (
    <DeleteDialogProvider>
      <GuideTabProvider>
        <UserProvider>
          <ReleaseFlagProvider>
            <Outlet />
          </ReleaseFlagProvider>
        </UserProvider>
      </GuideTabProvider>
    </DeleteDialogProvider>
  );
}

export { AppContainer };
